// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"b9d79272","488":"41075a52"}[chunkId] + ".chunk.js";
};